import { ConfirmDialog, useToast } from "@nabble/ui";
import { removeEmail, type AccountEmail } from "../../../../api/accountEmails";
import { emailErrorMessage } from "./emailErrors";

interface RemoveEmailDialogProps {
  /** The email to remove; the dialog is closed while there is none. */
  target: AccountEmail | null;
  onClose: () => void;
  onRemoved: () => void;
}

/** Confirms removing a secondary email from the account. */
export function RemoveEmailDialog({ target, onClose, onRemoved }: RemoveEmailDialogProps): React.JSX.Element {
  const { show } = useToast();
  return (
    <ConfirmDialog
      open={target !== null}
      tone="danger"
      icon="trash"
      title="Remove email"
      description={target ? `${target.email} will be removed from your account and can no longer be used to recover your password.` : undefined}
      confirmLabel="Remove"
      onClose={onClose}
      onConfirm={async () => {
        if (!target) return;
        try {
          await removeEmail(target.id);
          show({ title: "Email removed", tone: "success" });
          onRemoved();
        } catch (err) {
          show({ title: "We couldn't remove it", text: emailErrorMessage(err, "Please try again."), tone: "danger" });
        }
      }}
    />
  );
}
